/* eslint-disable no-unused-vars */
let baseId = 0;

/*
{
  func: Function,
  events: [],
  cacheCount: 10,
  formatResult: false,
  getKeyFromEvent: Function,
  getKeyFromArgs: Function
}
 */
class BaseCache {
  constructor(config = {}) {
    this._config = config;
    baseId += 1;
    this._name = `BaseCache@${baseId}`;
    this._func = config.func
    this._m_events = config.events || []
    this._data = {}
    this._cacheCount = config.cacheCount || 10
    this._registerEvents()
    this._keyList = []
    this._argsKeyCt = {}
    this._formatResult = config.formatResult
  }

  _event(event) {
    return `${this._name}#${event}`
  }
  $on(event, handler) {
    return this.$bus.$on(this._event(event), handler)
  }

  _$emit(event, data) {
    return this.$bus.$emit(this._event(event), data)
  }
  isHit(...args) {
    return !!(this._data[this.getKey(args)])
  }
  
  _registerEvents() {
    if (!this._m_events || !this._m_events.length) {
      return
    }
    console.debug('cache', this._m_events, ' register:', this._m_events)
    this.$bus.$on(this._m_events, this._clear.bind(this))
  }

  _clear(data) {
    console.debug('cache', this._m_events, '_clear')
    if(this._config.getKeyFromArgs) {
      const eventKey = this._config.getKeyFromEvent(data)
      if (this._argsKeyCt[eventKey]) {
        const key = this._argsKeyCt[eventKey]
        delete this._keyList[key]
        delete this._data[key]
        delete this._argsKeyCt[eventKey]
        this._$emit('clear', eventKey)
        return
      }
    }
    this._keyList = []
    this._data = {}
    this._$emit('clear', null)
  }

  getData(...args) {
    const key = this.getKey(args);
    if (this._config.getKeyFromArgs) {
      this._argsKeyCt[this._cacheCount.getKeyFromArgs(...args)]
    }
    console.debug('cache', this._m_events, 'args:', args)
    console.debug('cache', this._m_events, 'key:', key)
    const data = this._getFromCache(key)
    if (data) {
      if (this._formatResult) {
        return {isHit: true, data: data}
      }
      return data
    }
    // from func
    const res = this._func(...args)
    const setData = this._setToCache(key, res)
    if (this._formatResult) {
      return {isHit: false, data: setData}
    }
    return setData
  }
  _setToCache(key, res) {
    if(this._keyList.length >= this._cacheCount) {
      const removeKey = this._keyList.shift()
      if(this._data[removeKey]) {
        delete this._data[removeKey]
      }
    }
    this._keyList.push(key)
    //async
    if (res instanceof Promise) {
      return new Promise((resolve, reject) => {
        res.then(r1 => {
          this._data[key] = {type: 'async', content: r1}
          console.debug('cache', this._m_events, ' set: async', r1)
          resolve(r1)
        }, reject)
      })
    } else {
      //sync
      this._data[key] = {type: 'sync', content: res}
      console.debug('cache', this._m_events, ' set: sync', res)
      return res
    }
  }
  _getFromCache(key) {
    const data = this._data[key];
    // from cache
    if (data) {
      console.debug('cache', this._m_events, 'hit')
      if (data.type === 'sync') {
        console.debug('cache', this._m_events, 'get: sync', data.content)
        return data.content
      } else if (data.type === 'async') {
        return new Promise((resolve, reject) => {
          console.debug('cache', this._m_events, 'get: async', data.content)
          setTimeout(() => resolve(data.content))
        })
      }
    }
    console.debug('cache', this._m_events, 'miss')
    return null
  }
  getKey(args, keys, oKey) {
    const ks = keys || [];
    if (!args && args !== 0) {
      return '-'
    }
    if (Array.isArray(args)) {
      ks.push('<')
      args.forEach(i1 => this.getKey(i1, ks))
      ks.push('>')
    }
    else if (args.constructor === Object) {
      ks.push('<')
      Object.keys(args).forEach(oK => {
        ks.push(`${oK}@${this.getKey(args[oK])}@`)
      })
      ks.push('>')
    } else {
      if (oKey) {
        ks.push(`${oKey}-${args}`)
      } else {
        ks.push(`${args}`)
      }
    }
    if (!keys) {
      return ks.join('|')
    }
  }
}

const bc = BaseCache

export default bc
